import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { PotEvent } from '../../constants/constants';
import { formatDuration, toLinkHref } from '../../shared/class-schedule.util';

export interface ClassDetailsDialogData {
  pot: PotEvent;
  // Time zone the date and times are shown in, e.g. "IST"
  timeZoneLabel?: string;
}

export type EditScope = 'occurrence' | 'following' | 'series';

export type ClassDetailsDialogResult =
  | { action: 'edit' | 'delete'; pot: PotEvent; scope: EditScope }
  | { action: 'duplicate'; pot: PotEvent }
  | undefined;

@Component({
  selector: 'app-class-details',
  templateUrl: './class-details.component.html',
  styleUrls: ['./class-details.component.scss'],
})
export class ClassDetailsComponent {
  pot: PotEvent;

  constructor(
    private dialogRef: MatDialogRef<ClassDetailsComponent, ClassDetailsDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ClassDetailsDialogData
  ) {
    this.pot = data.pot;
  }

 


  get durationLabel(): string | null {
    return formatDuration(this.pot.startTime, this.pot.endTime);
  }

  // YYYY-MM-DD shown as DD-MM-YYYY
  displayDate(date: string): string {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }

  get locationHref(): string | null {
    return toLinkHref(this.pot.location);
  }

  edit(scope: EditScope = 'occurrence'): void {
    this.dialogRef.close({ action: 'edit', pot: this.pot, scope });
  }

  delete(scope: EditScope = 'occurrence'): void {
    this.dialogRef.close({ action: 'delete', pot: this.pot, scope });
  }

  duplicate(): void {
    this.dialogRef.close({ action: 'duplicate', pot: this.pot });
  }

  close(): void {
    this.dialogRef.close();
  }
}
